module.exports = __webpack_public_path__ + "media/icons/key-space-dark-d384f468.svg";